'use client'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import TorHeader from 'components/TorHeader'
import SelectFilter from 'components/SelectFilter'
import SecNav from 'components/SecNav'
import { torsCats } from 'config/const'
import { LeagueContext } from 'utils/context'
import { saveInLocalStorage } from 'utils/storage'
import { publicGetRequest } from 'services/one'

const mapCat = [
  {
    linkKeyword: 'absoluta',
    catName: 'ABSOLUTA',
    name: 'Lliga Catalana Absoluta'
  },
  {
    linkKeyword: 'veterans',
    catName: 'VETERANS',
    name: 'Lliga Catalana de Veterans'
  },
  {
    linkKeyword: 'veterans-senior',
    catName: 'Veterans Senior',
    name: 'Lliga Catalana de Veterans Sènior'
  },
  {
    linkKeyword: 'menors',
    catName: 'MENORS',
    name: 'Lliga Catalana de Menors'
  },
  {
    linkKeyword: 'descoles',
    catName: 'ESCOLES',
    name: 'Lliga Catalana d’Escoles'
  },
  {
    linkKeyword: 'femeni',
    catName: 'Interclubs Femeni',
    name: 'Interclubs Femení RACC'
  },
  {
    linkKeyword: 'senior',
    catName: 'Interclubs Barcelona',
    name: 'Interclubs Sènior Barcelona Ciutat'
  },
  {
    linkKeyword: 'anteriors',
    catName: 'Lligues Anteriors',
    name: 'Lligues Anteriors'
  },
  {
    linkKeyword: 'lliga',
    catName: 'Lligues Anteriors',
    name: 'Lligues Anteriors'
  }
]

const LeaguesLayout = ({ children }) => {
  const pathname = usePathname()
  const lastSlug = pathname.split('/').pop()
  const noHeader = lastSlug === 'lliga-catalana' || lastSlug === 'interclubs'
  const noContent = lastSlug === 'anteriors' || lastSlug === 'lliga'
  const showFilters = lastSlug !== 'info' && !noContent
  const torDetails = torsCats.find(({ torUrl }) => pathname.includes(torUrl))
  const pathParts = pathname.split('/')
  const leagueBaseUrl = pathParts.slice(0, pathParts.length - 1).join('/')
  const urlKeyword = pathParts
    .slice(pathParts.length - 2, pathParts.length - 1)
    .pop()
  const lastPart = pathParts.pop()
  const currentTor = mapCat.find(
    ({ linkKeyword }) => linkKeyword === urlKeyword || linkKeyword === lastPart
  )
  const title = currentTor?.name
  const [filtersData, setFiltersData] = useState([])
  const [categoryFilterSelected, setCategoryFilterSelected] = useState()
  const [categoriesFilter, setCategoriesFilter] = useState([])
  const [zoneFilterSelected, setZoneFilterSelected] = useState('')
  const [zoneFilter, setZoneFilter] = useState([])
  const [divisionFilterSelected, setDivisionFilterSelected] = useState('')
  const [divisionFilter, setDivisionFilter] = useState([])
  const [dayFilterSelected, setDayFilterSelected] = useState('')
  const [dayFilter, setDayFilter] = useState([])
  const [showClub, setShowClub] = useState(false)
  const [showJourneys, setShowJourneys] = useState(false)
  const [hideDayFilter, setHideDayFilter] = useState(false)

  const getFilters = async () => {
    const catName = currentTor?.catName
    if (catName) {
      const filtersReq = (
        await publicGetRequest({
          id: catName,
          endpoint: 'LEAGUES_FILTERS'
        })
      )?.Categories
      setFiltersData(filtersReq)
      setCategoriesFilter(
        filtersReq?.map((filter) => ({
          title: filter.categoryName,
          value: filter.categoryId
        }))
      )
      let filters = localStorage.getItem('filtersLeagues')
      filters = JSON.parse(filters)
      if (filters?.league === catName) {
        if (filters?.zone) {
          setZoneFilterSelected(filters.zone)
        }
        if (filters?.division) {
          setDivisionFilterSelected(filters.division)
        }
        if (filters?.day) {
          setDayFilterSelected(filters.day)
        }
        setCategoryFilterSelected(filters.category)
      } else {
        saveInLocalStorage('filtersLeagues', 'league', catName)
        saveInLocalStorage('filtersLeagues', 'category', '')
        if (!categoryFilterSelected) {
          setCategoryFilterSelected(filtersReq?.[0].categoryId)
        }
      }
      if (!categoryFilterSelected) {
        setCategoryFilterSelected(filtersReq?.[0].categoryId)
      }
    }
  }

  useEffect(() => {
    getFilters()
    // added pathname as from league home, for some reason doesn't work without this
  }, [pathname])

  useEffect(() => {
    if (filtersData?.length && categoryFilterSelected) {
      let filters = localStorage.getItem('filtersLeagues')
      filters = JSON.parse(filters)
      if (filters?.category !== categoryFilterSelected) {
        setZoneFilterSelected('')
        setDivisionFilterSelected('')
        setDayFilterSelected('')
        saveInLocalStorage('filtersLeagues', 'category', categoryFilterSelected)
        saveInLocalStorage('filtersLeagues', 'zone', '')
        saveInLocalStorage('filtersLeagues', 'division', '')
        saveInLocalStorage('filtersLeagues', 'day', '')
      }
      const zoneFilterData = filtersData
        .find(({ categoryId }) => categoryId === categoryFilterSelected)
        ?.zones.map(({ zoneName }) => ({
          title: zoneName,
          value: zoneName
        }))
      setZoneFilter(zoneFilterData)
      // if (zoneFilterData?.length === 1) {
      //   setZoneFilterSelected(zoneFilterData[0].value)
      // }
    }
  }, [categoriesFilter, categoryFilterSelected])

  useEffect(() => {
    if (filtersData?.length && zoneFilterSelected) {
      const divisionFilterData = filtersData
        .find(({ categoryId }) => categoryId === categoryFilterSelected)
        ?.zones.find(({ zoneName }) => zoneName === zoneFilterSelected)
        ?.divisions.map((zone) => ({
          title: zone.groupName,
          value: zone.groupId
        }))
      setDivisionFilter(divisionFilterData)
      // if (divisionFilterData?.length === 1) {
      //   setDivisionFilterSelected(divisionFilterData[0].value)
      // }
      saveInLocalStorage('filtersLeagues', 'zone', zoneFilterSelected)
    }
  }, [zoneFilterSelected])

  useEffect(() => {
    if (divisionFilterSelected) {
      setDayFilter(
        filtersData
          ?.find(({ categoryId }) => categoryId === categoryFilterSelected)
          ?.zones.find(({ zoneName }) => zoneName === zoneFilterSelected)
          ?.divisions.find(
            ({ groupId }) => `${groupId}` === divisionFilterSelected
          )
          ?.matchDays.map(({ matchDay }) => ({
            title: matchDay,
            value: matchDay
          }))
      )
      saveInLocalStorage('filtersLeagues', 'division', divisionFilterSelected)
    }
  }, [divisionFilterSelected])

  useEffect(() => {
    if (dayFilterSelected) {
      saveInLocalStorage('filtersLeagues', 'day', dayFilterSelected)
    }
  }, [dayFilterSelected])

  return (
    <LeagueContext.Provider
      value={{
        divisionFilterSelected,
        dayFilterSelected,
        showClub,
        setShowClub,
        showJourneys,
        setShowJourneys,
        setHideDayFilter,
        categoryFilterSelected,
        torDetails
      }}
    >
      {!noHeader && (
        <>
          <TorHeader
            title={title}
            img={torDetails.cardImg}
            color={torDetails.color}
            reduceBottomOfTitle
          />
          {!noContent && (
            <SecNav
              items={[
                {
                  name: 'Informació Lliga',
                  link: `${leagueBaseUrl}/info`
                },
                {
                  name: 'Resultats',
                  link: `${leagueBaseUrl}/resultats`
                },
                {
                  name: 'Classificació',
                  link: `${leagueBaseUrl}/classificacio`
                },
                {
                  name: 'Calendari',
                  link: `${leagueBaseUrl}/calendari`
                },
                {
                  name: 'Àrea Capità',
                  link: '/privat/federat/area-capita/lligues/lliga'
                }
              ]}
              bg="sec-grey-4"
            />
          )}
          <div className="mx-2 lg:mx-0">
            {showFilters && (
              <div
                className={`mt-16 ${(showClub || showJourneys) && 'hidden'}`}
              >
                <div className="max-w-6xl mx-auto">
                  <div className="grid grid-cols-1 lg:flex">
                    <SelectFilter
                      filters={categoriesFilter}
                      selected={categoryFilterSelected}
                      setSelected={setCategoryFilterSelected}
                      className="lg:w-[300px] lg:ml-3 mt-2 lg:mt-0"
                      value={categoryFilterSelected}
                    />
                    <SelectFilter
                      text="Zona"
                      filters={zoneFilter}
                      selected={zoneFilterSelected}
                      setSelected={setZoneFilterSelected}
                      value={zoneFilterSelected}
                      className="lg:w-[250px] lg:ml-3 mt-2 lg:mt-0"
                    />
                    <SelectFilter
                      text="Divisió"
                      filters={divisionFilter}
                      selected={divisionFilterSelected}
                      setSelected={setDivisionFilterSelected}
                      value={divisionFilterSelected}
                      className="lg:w-[350px] lg:ml-3 mt-2 lg:mt-0"
                    />
                    {!hideDayFilter && (
                      <SelectFilter
                        text="Jornada"
                        filters={dayFilter}
                        selected={dayFilterSelected}
                        setSelected={setDayFilterSelected}
                        value={dayFilterSelected}
                        className="lg:min-w-[150px] lg:ml-3 mt-2 lg:mt-0"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
      <div className="mx-2 lg:mx-0">{children}</div>
    </LeagueContext.Provider>
  )
}

export default LeaguesLayout
